import { PropsWithChildren } from 'react';
import styles from './Tile.module.scss';
import { TObject } from '@types';

type TileProps = {
	hasPadding?: boolean;
	hasBorder?: boolean;
	selected?: boolean;
	hasBorderRadius?: boolean;
	hasShadow?: boolean;
	stretch?: boolean;
	width?: number;
	height?: number;
	padding?: number;
	bgColor?: string;
	borderColor?: string;
	onClick?: () => void;
}

export const Tile = (props:PropsWithChildren<TileProps>) => {
	const {
		children,
		hasPadding = true,
		hasBorder = true,
		selected = false,
		hasBorderRadius = true,
		hasShadow = false,
		stretch = false,
		width,
		height,
		padding,
		bgColor,
		borderColor,
		onClick,
	} = props;
	const getClasses = () => {
		let classes = styles.container;
		if (hasPadding) classes = `${classes} ${styles.isPadded}`;
		if (hasBorder) classes = `${classes} ${styles.hasBorder}`;
		if (selected) classes = `${classes} ${styles.selected}`;
		if (!hasBorderRadius) classes = `${classes} ${styles.squared}`;
		if (hasShadow) classes = `${classes} ${styles.hasShadow}`;
		if (stretch && !hasPadding) classes = `${classes} ${styles.stretch}`;
		if (stretch && hasPadding) classes = `${classes} ${styles.stretchPadded}`;
		if (onClick) classes = `${classes} ${styles.pointer}`;

		return classes;
	}
	const setStyle = () => {
		const styles:TObject = {};
		if (width) styles.width = `${width}px`;
		if (height) styles.height = `${height}px`;
		if (padding) styles.padding = `${padding}px`;
		if (bgColor) styles.backgroundColor = bgColor;
		if (borderColor) styles.borderColor = borderColor;
		return styles;
	}
	return (
		<div data-testid={'@Layout-Tile'} className={getClasses()} style={setStyle()} onClick={onClick}>
			{children}
		</div>
	);
}
